import { render } from "./BudgetsListView.vue?vue&type=template&id=6fd47a41"
import script from "./BudgetsListView.vue?vue&type=script&lang=js"
export * from "./BudgetsListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__